var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tour-exit"},[_c('button',{staticClass:"tour-exit__btn",on:{"click":function($event){return _vm.$emit('quit')}}},[_vm._v("\n    "+_vm._s(_vm.$t('tours.nav.quit'))+"\n  ")])])}
var staticRenderFns = []

export { render, staticRenderFns }